import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@sigopos/ui/tokens.css'
import './app.css'
import { App } from './App'

const root = document.getElementById('root')
if (!root) throw new Error('Không tìm thấy #root trong index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
